import React from 'react';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';

import Button from 'components/Button';
import ErrorBlock from 'components/ErrorBlock';
import {ExpandingTextAreaField} from 'components/Fields';

import './styles.css';

const formSubmit = (values, _dispatch, props) => {
  const {newDescription} = values;

  props.submitAction({newDescription});
};

class EditDescriptionForm extends React.Component<any> {
  triggerSubmit = () => {
    this.props.submit(this.props.formName);
  };

  render() {
    const {error, submitting, handleSubmit} = this.props;

    return (
      <form className="EditDescriptionForm" onSubmit={handleSubmit}>
        {error && <ErrorBlock>{error}</ErrorBlock>}

        <Field
          name="newDescription"
          className="editArrivalRoomCheckDescription"
          component={ExpandingTextAreaField}
          minHeight="8rem"
          maxHeight="8rem"
        />
        <div className="buttons colab-row-space-between">
          <div className="colab-centered">
            <Button
              white
              className="cancelButton"
              type="button"
              onClick={this.props.hideEditDescriptionForm}>
              Cancel
            </Button>
            <Button
              className="editDescriptionButton"
              onClick={this.triggerSubmit}
              blue={!submitting}
              isLoading={submitting}
              disabled={submitting}>
              Save
            </Button>
          </div>
        </div>
      </form>
    );
  }
}

const mapStateToProps = (_state, props) => {
  const {description} = props;

  return {
    form: props.formName,
    initialValues: {
      newDescription: description
    }
  };
};

const editDescriptionForm = reduxForm({
  onSubmit: formSubmit
})(EditDescriptionForm);

export default connect(mapStateToProps)(editDescriptionForm);
